import { Alert } from '@cmpsr/components';
import React from 'react';

type ActionPlanGuidanceBannerProps = {
  onCloseBanner: () => void;
};

function ActionPlanGuidanceBanner({ onCloseBanner }: ActionPlanGuidanceBannerProps) {
  return (
    <Alert variant="subtle" status="info" maxW="740px" mb="spacer-4">
      <Alert.Icon />
      <Alert.Title pr="12px">
        We recommend you commit to an action item for 60 days before marking it complete.{' '}
        <Alert.Description pr="12px">
          This is the average amount of time it takes to form a new habit.
        </Alert.Description>
      </Alert.Title>
      <Alert.CloseButton onClick={onCloseBanner} />
    </Alert>
  );
}

export default React.memo(ActionPlanGuidanceBanner);
